import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { NavLink,useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReCAPTCHA from 'react-google-recaptcha';
import toast from "react-hot-toast";
const ContactUs = () => {
const navigate = useNavigate();
const headingVariants = {
hidden: { opacity: 0, x: 50 },
visible: (i) => ({
opacity: 1,
x: 0,
transition: {
delay: i * 0.1, // Delay for each letter
type: "spring",
stiffness: 120,
},
}),
};
const headingText = "Submit an Enquiry";
const [contactDetails, setContactDetails] = useState({
titleid: '',
firstName: '',
lastName: '',
phone: '',
email: '',
message: '',
reCaptcha: ''
});

const handleReCaptcha = (value) => {
setContactDetails((prev) => ({ ...prev, reCaptcha: value }));
};
const [errors, setErrors] = useState({});
const [isSubmitted, setIsSubmitted] = useState(false);
const [captchaVerified, setCaptchaVerified] = useState(false);
const validateForm = () => {
let errors = {};

if (!contactDetails.titleid.trim()) {
errors.titleid = 'Title is required';
}
if (!contactDetails.firstName.trim()) {
errors.firstName = 'First name is required';
}

if (!contactDetails.lastName.trim()) {
errors.lastName = 'Last name is required';
}

const phoneRegex = /^\d{10,15}$/;
if (!contactDetails.phone.trim()) {
errors.phone = 'Phone number is required';
} else if (!phoneRegex.test(contactDetails.phone)) {
errors.phone = 'Phone number must be between 10 digits';
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
if (!contactDetails.email.trim()) {
errors.email = 'Email is required';
} else if (!emailRegex.test(contactDetails.email)) {
errors.email = 'Invalid email format';
}

if (!contactDetails.message.trim()) {
errors.message = 'Message is required';
}

setErrors(errors);
return Object.keys(errors).length === 0;
};

const handleChange = (e) => {
setContactDetails({
...contactDetails,
[e.target.name]: e.target.value
});
};

const onReCaptchaChange = (value) => {
setCaptchaVerified(!!value); // Set to true if captcha is successfully validated
setContactDetails({ ...contactDetails, reCaptcha: value }); // Store captcha token
};

const trimFormData = (data) => {
const trimmedData = {};
Object.keys(data).forEach((key) => {
const value = data[key];
// Check if the value is a string, then trim it
trimmedData[key] = typeof value === "string" ? value.trim() : value;
});
return trimmedData;
};

const handleFormSubmit = async (event) => {
event.preventDefault();
window.grecaptcha.reset();
if (!validateForm()) {
return;
}

if (!validateForm()) return;

try {
const toastId = toast.loading(<b>Saving...</b>); // Show the loading toast
const trimmedFormData = trimFormData(contactDetails);
const response = await axios.post("https://msbassociationuk.org/prod/api/msb/savecontactdetails", trimmedFormData);

if (response.data.response && response.data.responseCode === "00") { // Success condition
toast.dismiss(toastId); // Dismiss the loading toast
toast.success(<b>Form submitted successfully!</b>);

contactDetails({
titleid: '',
firstName: '',
lastName: '',
phone: '',
email: '',
message: '',
reCaptcha: ''
});
} else { // Handle error from response
toast.dismiss(toastId);
toast.error(response.data.data || "Something went wrong. Please try again."); // Display error from API response
}
} catch (error) {
console.error(error);

}
};

const title = "Contact Us";

const letterVariants = {
hidden: { y: -50, opacity: 0 },
visible: (index) => ({
y: 0,
opacity: 1,
transition: {
delay: index * 0.1, // Delay each letter animation
duration: 0.4,
ease: "easeInOut",
},
}),
}
return (
<div>
  <Helmet>
    {/* Basic Meta Tags */}
    <title> Contact Us | MSB Association Support & Membership Queries</title>
    <meta name="description"
      content="Contact the MSB Association for support, membership queries, and expert guidance. We're here to help Money Service Businesses succeed and stay compliant." />

    {/* Open Graph Meta Tags */}
    <meta property="og:title" content="Contact Us | MSB Association Support & Membership Queries " />
    <meta property="og:description"
      content="Contact the MSB Association for support, membership queries, and expert guidance. We're here to help Money Service Businesses succeed and stay compliant." />

    <meta property="og:type" content="website" />

    {/* Twitter Meta Tags */}
  </Helmet>
  <main className="page_content">
    {/* Page Header - Start
    ================================================== */}
    <section className="page_header text-center section_decoration overflow-hidden" style={{background: "#333"}}>
      <div className="container">
        <motion.h1 className="page_title text-white" initial="hidden" animate="visible"
          style={{ display: "flex", justifyContent: "center" }}>
          {title.split("").map((letter, index) => (
          <motion.span key={index} custom={index} variants={letterVariants}
            style={{ display: "inline-block", marginRight: letter === " " ? "0.3rem" : "0" }}>
            {letter}
          </motion.span>
          ))}
        </motion.h1>
        <ul className="breadcrumb_nav unordered_list justify-content-center">
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li className="active"><a href="#!">Contact Us</a></li>
        </ul>
      </div>

    </section>
    {/* Page Header - End
    ================================================== */}
    {/* Contact Section - Start
    ================================================== */}
    <section className="contact_section section_space bg-dark">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="comment_form p-lg-5">
              <div className="heading_block">
                <h2 className="heading_text">
                  {headingText.split("").map((char, i) => (
                  <motion.span key={`${char}-${i}`} custom={i} initial="hidden" animate="visible"
                    variants={headingVariants}>
                    {char}
                  </motion.span>
                  ))}
                </h2>
                <p className="heading_description mb-0">
                  How we can help you?
                </p>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="row">
                  <div className="col-md-2 col-2 mb-2">
                    <div className="form-group">
                      <label className="input_title" htmlFor="title">Title<sup>*</sup></label>
                      <select id="titleid" className={`form-control p-3 ${errors.titleid ? "bg-danger" : "" }`}
                        name="titleid" value={contactDetails.titleid} onChange={handleChange}>
                        <option value="">Select Title</option>
                        {[
                        { label: "Mr.", value: 1 },
                        { label: "Mrs.", value: 2 },
                        { label: "Miss", value: 3 },
                        { label: "Dr.", value: 4 },
                        ].map((title) => (
                        <option key={title.value} value={title.value}>
                          {title.label}
                        </option>
                        ))}
                      </select>

                      {errors.titleid && <span className="text-danger">{errors.titleid}</span>}
                    </div>
                  </div>
                  <div className="col-10 col-md-10 mb-2">
                    <div className="form-group">
                      <label htmlFor="input_name" className="input_title">
                        First Name<sup>*</sup>
                      </label>
                      <input id="input_name" className={`form-control ${ errors.firstName ? "bg-danger" : "" }`}
                        type="text" name="firstName" placeholder="Enter Your First Name"
                        value={contactDetails.firstName} onChange={handleChange} />
                      {errors.firstName && (
                      <small className="text-danger">{errors.firstName}</small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 mb-2">
                    <div className="form-group">
                      <label htmlFor="input_name" className="input_title">
                        Last Name<sup>*</sup>
                      </label>
                      <input id="input_name" className={`form-control ${ errors.lastName ? "bg-danger" : "" }`}
                        type="text" name="lastName" placeholder="Enter Your Last Name" value={contactDetails.lastName}
                        onChange={handleChange} />
                      {errors.lastName && (
                      <small className="text-danger">{errors.lastName}</small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 mb-2">
                    <div className="form-group">
                      <label htmlFor="input_email" className="input_title">
                        Email<sup>*</sup>
                      </label>
                      <input id="input_email" className={`form-control ${ errors.email ? "bg-danger" : "" }`}
                        type="email" name="email" placeholder="Enter Your Email Id" value={contactDetails.email}
                        onChange={handleChange} />
                      {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 mb-2">
                    <div className="form-group ">
                      <label htmlFor="input_phone" className="input_title">
                        Phone<sup>*</sup>
                      </label>
                      <input id="input_phone" className={`form-control ${ errors.phone ? "bg-danger" : "" }`} type="tel"
                        name="phone" placeholder="Enter Your Phone / Mobile Number" value={contactDetails.phone}
                        onChange={handleChange} />
                      {errors.phone && (
                      <small className="text-danger">{errors.phone}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12 mb-3 mt-3">
                    <div className="form-group">
                      <label htmlFor="input_message" className="input_title">
                        Message<sup>*</sup>
                      </label>
                      <textarea id="input_message" className={`form-control ${ errors.message ? "bg-danger" : "" }`}
                        name="message" placeholder="Enter Your Message" value={contactDetails.message}
                        onChange={handleChange} />
                      {errors.message && (
                        <small className="text-danger">{errors.message}</small>
                      )}
                    </div>
                  </div>
                  
                  <div className="col-md-12 mt-3 mb-2">
           
                  <ReCAPTCHA
                    sitekey="6LfmsZoqAAAAAPQgbaeEuX7w8IZxz7Ncqgs2i0hY"
                    onChange={handleReCaptcha}
                    onErrored={() =>
                      setErrors((prev) => ({ ...prev, captcha: "Captcha verification failed." }))
                    }
                  />
                  {errors.reCaptcha && <span className="text-danger">{errors.reCaptcha}</span>}

                          </div>
         
                  <div className="col-md-12">
                    
                  <button className="btn text-dark" type="submit">
                      <span className="btn_label">Send Message</span>
                      <span className="btn_icon ml-10">
                        <svg
                          width={20}
                          height={16}
                          viewBox="0 0 20 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 9H19V7H0V9Z"
                            fill="#012A2B"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>

                  
                </div>
              </form>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="contact_info_box p-5">
            <h3 className="heading_text">Contact Info</h3>
            <ul className="iconlist_block unordered_list_block">
              <li>
                <a href="tel:442045873789">
                  <span className="iconlist_icon">
                    <img src="assets/images/icons/icon_calling_3.svg" alt="Icon Calling" />
                  </span>
                  <span className="iconlist_text">+44 20 4587 3789</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@msbassociationuk.org">
                  <span className="iconlist_icon">
                    <img src="assets/images/icons/icon_email_3.svg" alt="Icon Email" />
                  </span>
                  <span className="iconlist_text">info@msbassociationuk.org</span>
                </a>
              </li>

              <li>
              {/* <a href="#!">
              <span className="iconlist_icon"> <i className="fa-solid fa-map-marker-alt" style={{background: "#fff", borderRadius: "50%", padding: '4px', marginRight: '10px'  }} />
              85 Marlyon Road, London IG6 3XW </span>
            </a> */}
              </li>
            </ul>
  
       
         
          </div>
        </div>
      </div>
    </div>
  </section>

</main>

    </div>
  )
}

export default ContactUs